import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useI18n } from "../../contexts/I18nContext";
import { Receipt, AlertCircle } from "lucide-react";

export default function AdminInvoices() {
  const { t } = useI18n();
  const [invoices, setInvoices] = useState(null);

  useEffect(() => {
    api.get("/admin/invoices").then((r) => setInvoices(r.data)).catch(() => setInvoices([]));
  }, []);

  return (
    <div className="surface-card overflow-hidden" data-testid="admin-invoices">
      <header className="px-6 py-5 border-b border-zinc-200/80 flex flex-wrap items-center gap-3">
        <h2 className="font-display font-semibold text-xl tracking-tight">{t("admin_invoices_title")}</h2>
        <span className="chip ms-auto">
          {invoices == null ? "—" : `${invoices.length} ${t("admin_invoices_count")}`}
        </span>
      </header>

      {invoices != null && invoices.length === 0 && (
        <div className="px-6 py-10 text-center" data-testid="admin-invoices-empty">
          <div className="w-12 h-12 rounded-2xl bg-zinc-100 grid place-items-center mx-auto mb-4">
            <Receipt className="w-6 h-6 text-zinc-400" strokeWidth={1.6} />
          </div>
          <p className="font-medium">{t("admin_invoices_empty_title")}</p>
          <p className="text-sm text-zinc-500 mt-1.5 max-w-sm mx-auto">{t("admin_invoices_empty_sub")}</p>
          <div className="mt-5 inline-flex items-center gap-2 chip">
            <AlertCircle className="w-3.5 h-3.5" strokeWidth={2} />
            {t("admin_invoices_stripe_pending")}
          </div>
        </div>
      )}

      {invoices != null && invoices.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 text-zinc-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-start px-6 py-3 font-medium">{t("admin_invoices_col_id")}</th>
                <th className="text-start px-6 py-3 font-medium">{t("admin_invoices_col_user")}</th>
                <th className="text-start px-6 py-3 font-medium">{t("admin_invoices_col_amount")}</th>
                <th className="text-start px-6 py-3 font-medium">{t("admin_invoices_col_status")}</th>
                <th className="text-start px-6 py-3 font-medium">{t("admin_invoices_col_date")}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-100">
              {invoices.map((inv, i) => (
                <tr key={i}>
                  <td className="px-6 py-3.5 font-mono text-xs">{inv.id || "—"}</td>
                  <td className="px-6 py-3.5">{inv.user_email || inv.user_id || "—"}</td>
                  <td className="px-6 py-3.5 font-mono">${((inv.amount || 0) / 100).toFixed(2)}</td>
                  <td className="px-6 py-3.5">
                    <span className="chip">{inv.status || "—"}</span>
                  </td>
                  <td className="px-6 py-3.5 text-xs text-zinc-500">{(inv.created_at || "").split("T")[0]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
